import Badge from "./Badge";
import Button from "./Button";
import Heading from "./Heading";
import Input from "./Input";
import Avatar from "./Avatar";
import { ModalContent } from "./Modal";
import PinInput from "./PinInput";

export default { Badge, Button, Heading, Input, ModalContent, Avatar, PinInput };
